// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-business-permissions-EditRoleAccessList-CheckerButton-CheckerButton-module__button--wfrXZ {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 100%;
  background: #fff;
  border: none;
  color: #e43d00;
  cursor: pointer;
}
/*# sourceMappingURL=CheckerButton.module.css.map */`, "",{"version":3,"sources":["webpack://./CheckerButton.module.less","webpack://./src/business/permissions/EditRoleAccessList/CheckerButton/CheckerButton.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;ACCF;AACA,mDAAmD","sourcesContent":[".button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  width: 100%;\n  background: #fff;\n  border: none;\n  color: #e43d00;\n  cursor: pointer;\n}\n",".button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  width: 100%;\n  background: #fff;\n  border: none;\n  color: #e43d00;\n  cursor: pointer;\n}\n/*# sourceMappingURL=CheckerButton.module.css.map */"],"sourceRoot":""}]);
// Exports
export var button = `src-business-permissions-EditRoleAccessList-CheckerButton-CheckerButton-module__button--wfrXZ`;
export default ___CSS_LOADER_EXPORT___;
